import React, { useMemo } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import PropTypes from 'prop-types'
import DenaliLogo from '../common/DenaliLogo'
import FlexColumn from '../../../../components/molecules/FlexColumn'

const greetings = [
  'Welcome, __.',
  '__, ready to explore?',
  '__, ready to dive in?',
  '__, what’s new today?',
  'Welcome back __.',
  '__, here we go.',
  '__, what do you want to uncover?',
  'Good to see you, __.',
  '__, what’s next?',
  'Let’s explore, __!',
  '__, your insights await.',
  '__, let’s begin.',
  '__, let\'s discover something new!',
  'Hi there __.',
  '__, we’re ready when you are.',
  'Insights, incoming, __.',
  '__, welcome back, explorer.',
  'Good to see you, __.',
  '__, you’re back!',
  '__, back at it?',
  '__, good to see you again.',
  '__, there you are.',
  '__, time to dig in.',
  '__, where to first?',
  '__, ready when you are.',
  '__, let\'s do something great today.'
]

function Greetings ({ isMobile }) {
  const authState = useOktaAuth()

  const message = useMemo(() => {
    if (!authState) return null
    const nameToUse = authState.authState.idToken.claims.name.split(' ').at(0)
    const jti = authState.authState.accessToken.claims.jti

    // Generate a consistent index from the JTI
    // Sum up character codes and use modulo to get an index
    const jtiHash = jti.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
    const greetingIndex = jtiHash % greetings.length

    // Pick the greeting and replace __ with the user's name
    const selectedGreeting = greetings[greetingIndex]
    return selectedGreeting.replace('__', nameToUse)
  }, [authState])

  if (!message) return null

  return (
    <FlexColumn className='items-center gap-md w-full px-4'>
      <div>
        <DenaliLogo size='150px' />
      </div>
      <div className='font-serif' style={{ fontWeight: 'normal', fontSize: isMobile ? 'var(--font-size-md)' : '48px', color: 'var(--dai-color-text)' }}>
        {message}
      </div>
    </FlexColumn>
  )
}

Greetings.propTypes = {
  isMobile: PropTypes.bool
}

Greetings.defaultProps = {
  isMobile: false
}

export default Greetings
